import * as yup from "yup";
const today = new Date();
const maxDate = new Date(today);
maxDate.setDate(today.getDate() + 30);

export const followUpSchema = yup.object().shape({
  followUp: yup.string().when("enquiry_related_to", {
    is: "Sales",
    then: (schema) => schema.required("Required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  followUpStatus: yup.string(),
  followUpDate: yup.date().when("enquiry_related_to", {
    is: "Sales",
    then: (schema) =>
      schema
        .max(maxDate, "Follow-up date must be within 30 days from today")
        .required("Follow-up date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  videoCall: yup.boolean(),
  followupTaken: yup.boolean(),
});

export const NewLeadSchema = yup.object().shape({
  preferred_language: yup.string().required("Preferred language is required"),

  first_name: yup.string().required("First name is required"),

  last_name: yup.string(),

  email: yup.string().email("Invalid email"),

  contact_number: yup
    .string()
    .matches(/^[0-9]{10}$/, "Contact number must be exactly 10 digits")
    .required("Contact number is required"),

  whatsapp_number: yup
    .string()
    .matches(/^[0-9]{10}$/, "Whatsapp number must be exactly 10 digits")
    .nullable(),

  enquiry_related_to: yup.string().required("Please select enquiry type"),

  // CONDITIONAL FIELDS
  prior_knowledge_of_farming: yup.string().when("enquiry_related_to", {
    is: "Sales",
    then: (schema) => schema.required("Please select prior knowledge level"),
    otherwise: (schema) => schema.notRequired(),
  }),

  interested_in: yup.array().when("enquiry_related_to", {
    is: "Sales",
    then: (schema) => schema.min(1, "Select at least one interest"),
    otherwise: (schema) => schema.notRequired(),
  }),

  // interested_in: yup.array().min(1, "Select at least one interest"),s

  // farm_construction_location: yup.string(),
  farm_construction_location: yup.string().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.required("Location is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  farm_construction_state: yup.string().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.required("State is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  farm_land_type: yup.string().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.required("Land type is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  total_area_available: yup.string().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.required("Area is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  facilities: yup.array().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.min(1, "Select at least one facility"),
    otherwise: (schema) => schema.notRequired(),
  }),

  tentative_start_time: yup.string().when("interestedIn", {
    is: "farm construction",
    then: (schema) => schema.required("Start time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  prior_knowledge_of_farming: yup.string().when("enquiry_related_to", {
    is: "Sales",
    then: (schema) => schema.required("Please select option"),
    otherwise: (schema) => schema.notRequired(),
  }),

  looking_for_loan: yup.boolean(),

  notes: yup.string(),

  origin: yup.string(),
  lead_alloted_to: yup.string(),

  customer_type: yup.string(),
  experience_level: yup.string(),
  occupation: yup.string(),

  lead_status: yup.string(),

  lead_alloted_to: yup.string(),
  location_type: yup.string(),
  land_available: yup.string(),
  funding_type: yup.string(),
  subsidy_interest: yup.string(),
  timeline: yup.string(),
  decision_stage: yup.string(),
  isfreeLancer: yup.string(),
  followUp: yup.array().of(followUpSchema),
});
